/**
=========================================================
* INTELLIV Panou de Control React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// INTELLIV Panou de Control React components
import SoftBox from "components/SoftBox";

// INTELLIV Panou de Control React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";

import { useState, useEffect } from "react";
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";
import Modal from "react-modal";
// Data
import timelineData from "layouts/pages/projects/timeline/data/timelineData";

import axios from "axios";
import { Navigate } from "react-router-dom";
import SoftTypography from "components/SoftTypography";

import { Popconfirm, Image } from "antd";

import SoftEditor from "components/SoftEditor";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Swal from "sweetalert2";
import { token } from "stylis";
import Upload from "antd/es/upload/Upload";
import IconClose from "examples/Icons/CloseButton";

//let testJson = require("./test.json");
const api_url = process.env.REACT_APP_API_URL;
Modal.setAppElement("#root");

/*
axios
  .get(api_url + "all")
  .then((response) => {
    var message = response.data.message;
    var obj = JSON.parse(message);
    console.log(obj);
    data = obj;
  })
  .catch(function (error) {
    console.log(error);
  });

axios
  .get(api_url + "names")
  .then((response) => {
    var message = response.data.message;
    var obj = JSON.parse(message);
    names = obj;
  })
  .catch(function (error) {
    console.log(error);
  });
  */

const letters = "ABCDEFGHIÎJKLMNOPQRSŞTŢUVWXYZ".split("");

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike", { "script": "super" }], // toggled buttons
    ["clean"], // remove formatting button
  ],
};

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
//faq collapse dictionary

function TimelineEliv() {
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [faqTable, setFaqTable] = useState({});
  const [data, setData] = useState([]);
  const [names, setNames] = useState([]);
  

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalName, setModalName] = useState("");
  const [modalText, setModalText] = useState("");
  const [modalScrieri, setModalScrieri] = useState("");
  const [modalBibliografie, setModalBibliografie] = useState("");
  const [modalTraduceri, setModalTraduceri] = useState("");
  const [modalEditii, setModalEditii] = useState("");
  const [modalId, setModalId] = useState(-1);
  const [modalImages, setModalImages] = useState([]);
  const [filelist, setFilelist] = useState([]); //for images
  const [modalLegends, setModalLegends] = useState([]); //for image legends

  const [edit, setEdit] = useState(true);

  const switchFaqTable = (name) => () => {
    setFaqTable({ ...faqTable, [name]: !faqTable[name] });
  };

  const handleEdit =
    (
      title,
      name,
      text,
      scrieri,
      editii,
      traduceri,
      bibliografie,
      imagini,
      legends,
      id
    ) =>
    () => {
      if (!name || !text || !id) {
        setEdit(false);
      } else {
        setEdit(true);
      }
      console.log("legends", legends);
      if (!scrieri) scrieri = [];
      if (!bibliografie) bibliografie = [];
      if (!traduceri) traduceri = [];
      if (!editii) editii = [];
      if (!imagini) imagini = [];
      if (!legends) legends = [];

      //transform text, scrieri, bibliografie from array to html, each being a paragraph
      var textTemp = "";
      var scrieriTemp = "";
      var bibliografieTemp = "";
      var traduceriTemp = "";
      var editiiTemp = "";
      var imaginiTemp = [];
      var legendsTemp = legends;
      text.forEach((item) => {
        textTemp += "<p>" + item + "</p>";
      });
      scrieri.forEach((item) => {
        scrieriTemp += "<p>" + item + "</p>";
      });
      bibliografie.forEach((item) => {
        bibliografieTemp += "<p>" + item + "</p>";
      });
      traduceri.forEach((item) => {
        traduceriTemp += "<p>" + item + "</p>";
      });
      editii.forEach((item) => {
        editiiTemp += "<p>" + item + "</p>";
      });
      imagini.forEach((item) => {
        //item is a html string of a image element.
        //we need the src attribute
        var src = item.match(/src="([^"]*)/)[1];
        imaginiTemp.push(src);
      });
      if (legendsTemp.length == 0) {
        //for each image add a legend
        legendsTemp = [];
        imaginiTemp.forEach((item) => {
          legendsTemp.push(" ");
        });
      }

      text = textTemp;
      scrieri = scrieriTemp;
      bibliografie = bibliografieTemp;
      traduceri = traduceriTemp;
      editii = editiiTemp;
      setModalTitle(title);
      setModalName(name);
      setModalText(text);
      setModalScrieri(scrieri);
      setModalBibliografie(bibliografie);
      setModalTraduceri(traduceri);
      setModalEditii(editii);
      setModalId(id);
      setModalImages(imagini);
      setModalLegends(legendsTemp);
      setModalIsOpen(true);
    };

  const handleDelete = (id) => () => {
    //delete entry
    var url = api_url + "/eliv/id?id=" + id;
    var jwToken = localStorage.getItem("token");
    const headers = {
      Authorization: "Bearer " + jwToken,
    };
    axios
      .delete(url, { headers: headers })
      .then((response) => {
        console.log(response.data);
        //force rerender
        var tempLetter = letter ? letter : "A";
        setLetter("");
        setTimeout(() => {
          setLetter(tempLetter);
        }, 2500);
        //throw swal success
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "Articolul a fost șters cu succes!",
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
      });
  };

  const handleSave = () => {
    setModalLoading(true);
    console.log("save");
    //remove <p> from text, scrieri, bibliografie, and split by </p>
    var textTemp = modalText.replace(/<\/p><p>/g, "|||").split("|||");
    var scrieriTemp = modalScrieri.replace(/<\/p><p>/g, "|||").split("|||");
    var bibliografieTemp = modalBibliografie
      .replace(/<\/p><p>/g, "|||")
      .split("|||");
    var traduceriTemp = modalTraduceri.replace(/<\/p><p>/g, "|||").split("|||");
    var editiiTemp = modalEditii.replace(/<\/p><p>/g, "|||").split("|||");

    textTemp = textTemp.map((text) => text.replace(/<p>|<\/p>/g, ""));
    scrieriTemp = scrieriTemp.map((text) => text.replace(/<p>|<\/p>/g, ""));
    bibliografieTemp = bibliografieTemp.map((text) =>
      text.replace(/<p>|<\/p>/g, "")
    );
    traduceriTemp = traduceriTemp.map((text) => text.replace(/<p>|<\/p>/g, ""));
    editiiTemp = editiiTemp.map((text) => text.replace(/<p>|<\/p>/g, ""));

    var imgTemp = modalImages;
    //send data to api
    var url;
    edit ? (url = api_url + "/eliv/update-id") : (url = api_url + "/eliv/add");
    const requestBody = {
      id: parseInt(modalId),
      newText: textTemp,
      newName: modalName,
      newWritings: scrieriTemp,
      newBiblio: bibliografieTemp,
      newTranslations: traduceriTemp,
      newEditions: editiiTemp,
      newImages: imgTemp,
      newLegends: modalLegends,
    };
    var jwToken = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwToken,
    };

    axios
      .post(url, requestBody, { headers: headers })
      .then((response) => {
        console.log(response.data);
        setModalIsOpen(false);

        //throw swal success
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "Articolul a fost modificat cu succes!",
        });
        setModalLoading(false);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
        setModalLoading(false);
      });
    //force rerender
    var tempLetter = letter ? letter : "A";
    setLetter("");
    setTimeout(() => {
      setLetter(tempLetter);
    }, 2500);
  };

  const [letter, setLetter] = useState("A");
  useEffect(() => {
    setLoading(true);
    var temp_letter = letter ? letter : "A";
    console.log(api_url + `/eliv/all_by_letter/${temp_letter}`);
    axios.get(api_url + `/eliv/all_by_letter/${temp_letter}`).then(
      (response) => {
        var message = response.data.message;
        var obj = JSON.parse(message);
        setData(obj);
        setLoading(false);
      },
      [letter]
    );
  }, [letter]);
  
  useEffect(() => {
    setLoading(true);
    var dataTemp = data;
    var nameObj = {};
    dataTemp.map((item) => {
      nameObj[item["_source"].name + " #" + item["_source"].id] = 1;
    });

    var namesTemp = Object.keys(nameObj);
    //sort alphabetically
    namesTemp.sort(function (a, b) {
      //compare keeping in mind romanian diacritics
      return a.localeCompare(b, "ro", { sensitivity: "base" });
    });

    setNames(namesTemp);
    setLoading(false);
  }, [data]);

  useEffect(() => {
    setLoading(true);
    //faq table when names change
    var faqTableTemp = {};
    names.map((name) => {
      faqTableTemp[name] = 0;
    });
    setFaqTable(faqTableTemp);
    setLoading(false);
  }, [names]);

  const namesElement =
    faqTable &&
    names &&
    names.map((name) => {
      return (
        <FaqCollapse
          title={name}
          key={name}
          open={faqTable[name]}
          onClick={switchFaqTable(name)}
        >
          {data.map((item) => {
            if (name != item["_source"].name + " #" + item["_source"].id)
              return <></>;
            var text = [];
            var scrieri = [];
            var bibliografie = [];
            var traduceri = [];
            var editii = [];
            var img = [];
            var legende = [];
            try {
              item["_source"].text.forEach((item, index) => {
                // Create a div for each item in the text array and add to the text array
                text.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            try {
              item["_source"].writings.forEach((item, index) => {
                scrieri.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            try {
              item["_source"].biblio.forEach((item, index) => {
                bibliografie.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            try {
              item["_source"].translations.forEach((item, index) => {
                traduceri.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            try {
              item["_source"].editions.forEach((item, index) => {
                editii.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            try {
              item["_source"].images.forEach((item, index) => {
                img.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item } }
                    ></div>
                  </SoftTypography>
                  
                );
              });
            } catch (err) {}
            try {
              item["_source"].legends.forEach((item, index) => {
                legende.push(
                  <SoftTypography
                    key={index}
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></div>
                  </SoftTypography>
                );
              });
            } catch (err) {}
            return (
              <>
                <SoftBox
                  style={{ display: "inline-block" }}
                  key={item["_source"].id}
                  p={0.5}
                  mb={1.5}
                  onClick={handleEdit(
                    "Editare intrare",
                    item["_source"].name,
                    item["_source"].text,
                    item["_source"].writings,
                    item["_source"].editions,
                    item["_source"].translations,
                    item["_source"].biblio,
                    item["_source"].images,
                    item["_source"].legends,
                    item["_source"].id
                  )}
                >
                  <SoftTypography
                    className="cursor-pointer"
                    variant="h6"
                    fontWeight="bold"
                    color="text"
                    key={item["_source"].id}
                  >
                    ✎ Editare
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  style={{ display: "inline-block" }}
                  key={item["_source"].id + 1000}
                  p={0.5}
                  mb={1.5}
                >
                  <Popconfirm
                    title="Sigur doriți să ștergeți articolul?"
                    onConfirm={handleDelete(item["_id"])}
                    okText="Da"
                    cancelText="Nu"
                  >
                    <SoftTypography
                      className="cursor-pointer"
                      variant="h6"
                      fontWeight="bold"
                      color="text"
                      key={item["_source"].id}
                    >
                      🗑 Ștergere
                    </SoftTypography>
                  </Popconfirm>
                </SoftBox>

                <TimelineItem
                  icon="inventory_2"
                  //key from index i
                  key={item["_source"].id + 40000}
                  dateTime=""
                  color="info"
                  title={"Text"} //todo
                  children={text}
                />
                {scrieri.length > 0 && (
                  <TimelineItem
                    icon="inventory_2"
                    //key from index i
                    key={item["_source"].id + 30000}
                    dateTime=""
                    color="info"
                    title={"Scrieri"} //todo
                    description={scrieri}
                  />
                )}
                {editii.length > 0 && (
                  <TimelineItem
                    icon="inventory_2"
                    //key from index i
                    key={item["_source"].id + 50000}
                    dateTime=""
                    color="info"
                    title={"Editii"} //todo
                    description={editii}
                  />
                )}
                {traduceri.length > 0 && (
                  <TimelineItem
                    icon="inventory_2"
                    //key from index i
                    key={item["_source"].id + 10000}
                    dateTime=""
                    color="info"
                    title={"Traduceri"} //todo
                    description={traduceri}
                  />
                )}

                {bibliografie.length > 0 && (
                  <TimelineItem
                    icon="inventory_2"
                    //key from index i
                    key={item["_source"].id + 20000}
                    dateTime=""
                    color="info"
                    title={"Bibliografie"} //todo
                    description={bibliografie}
                  />
                )}
                {img.length > 0 && (
                  img.map((image, idx) =>{
                  return idx === 0 ? (
                  <div className="image-container">
                    <TimelineItem
                      icon="inventory_2"
                      //key from index i
                      key={item["_source"].id + 60000 + idx}
                      dateTime=""
                      color="info"
                      title={"Imagini"} //todo
                      description={image}
                      legend={legende[idx]}
                    />
                  </div>
                  )
                  : (
                    <div className="image-container">
                    <TimelineItem
                      icon=""
                      //key from index i
                      key={item["_source"].id + 60000 + idx}
                      dateTime=""
                      color="info"
                      //title={"Imagini"} //todo
                      description={image}
                      legend={legende[idx]}
                    />
                  </div>
                  )
                  })
                )}
              </>
            );
          })}
        </FaqCollapse>
      );
    });
  //check if logged in

  return (
    <>
      <Modal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Editare intrare"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 10000, // Set the z-index here
          },
          content: {
            color: "lightsteelblue",
          },
        }}
      >
        <SoftBox p={3}>
          <div className="close-button">
        <SoftButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  setModalIsOpen(false);
                  // set modal content to default values
                  setModalName("");
                  setModalText("");
                  setModalScrieri("");
                  setModalBibliografie("");
                  setModalId("");
                  setModalTraduceri("");
                  setModalEditii("");
                  setModalImages([]);
                }}
              >
              <IconClose/>
          </SoftButton>
          </div>
          <SoftTypography variant="h3" component="h3">
            <div style={{ textAlign: "center"}}>{modalTitle}</div>
          </SoftTypography>
          <SoftBox my={5}>
            <SoftTypography variant="h4" component="h4">
              <div>Nume</div>
            </SoftTypography>
            <SoftInput
              value={modalName}
              onChange={(e) => {
                setModalName(e.target.value);
              }}
              placeholder="Nume"
            />

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Text</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalText ? modalText : ""}
                onChange={(value) => {
                  setModalText(value);
                }}
              />
            </SoftBox>

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Scrieri</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalScrieri ? modalScrieri : ""}
                onChange={(value) => {
                  setModalScrieri(value);
                }}
              />
            </SoftBox>

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Traduceri</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalTraduceri ? modalTraduceri : ""}
                onChange={(value) => {
                  setModalTraduceri(value);
                }}
              />
            </SoftBox>

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Ediții</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalEditii ? modalEditii : ""}
                onChange={(value) => {
                  setModalEditii(value);
                }}
              />
            </SoftBox>

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Bibliografie</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalBibliografie ? modalBibliografie : ""}
                onChange={(value) => {
                  setModalBibliografie(value);
                }}
              />
            </SoftBox>

            <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Imagini</div>
              </SoftTypography>
              <div className="editImagesSection">
                {modalImages.map((image, index) => {
                  return (
                    <>
                      <div
                        style={{
                          backgroundColor: "lightsteelblue",
                          padding: "10px",
                          marginBottom: "10px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>#{index + 1}</div>
                        {/* arrows to move up and down in order,if first element NO up arrow, if last element NO down arrow */}
                        <div
                          className="editImageContainer-wrapper-image"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          {index != 0 && (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                var temp = modalImages;
                                var tempLegends = modalLegends;
                                var tempImg = temp[index];
                                var tempLeg = tempLegends[index];
                                temp[index] = temp[index - 1];
                                tempLegends[index] = tempLegends[index - 1];
                                temp[index - 1] = tempImg;
                                tempLegends[index - 1] = tempLeg;
                                setModalImages([]);
                                setModalLegends([]);
                                setTimeout(() => {
                                  setModalImages(temp);
                                  setModalLegends(tempLegends);
                                }, 200);
                              }}
                            >
                              ⬆
                            </button>
                          )}
                          {index != modalImages.length - 1 && (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                var temp = modalImages;
                                var tempLegends = modalLegends;
                                var tempImg = temp[index];
                                var tempLeg = tempLegends[index];
                                temp[index] = temp[index + 1];
                                tempLegends[index] = tempLegends[index + 1];
                                temp[index + 1] = tempImg;
                                tempLegends[index + 1] = tempLeg;
                                setModalImages([]);
                                setModalLegends([]);
                                setTimeout(() => {
                                  setModalImages(temp);
                                  setModalLegends(tempLegends);
                                }, 200);
                              }}
                            >
                              ⬇
                            </button>
                          )}

                          <button
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              var temp = modalImages;
                              var tempLegends = modalLegends;
                              temp.splice(index, 1);
                              tempLegends.splice(index, 1);
                              setModalImages([]);
                              setModalLegends([]);
                              setTimeout(() => {
                                setModalImages(temp);
                                setModalLegends(tempLegends);
                              }, 200);
                            }}
                          >
                            ✖ Șterge
                          </button>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <div className="editImageContainer">
                          <img
                            src={image.match(/src="([^"]*)/)[1]}
                            alt="Imagine"
                            style={{ width: "20vw", borderRadius: "10px" }}
                          />
                          <div className="editImageOverlay"></div>
                          {/* <div
                            className="editImageDelete"
                            onClick={() => {
                              var temp = modalImages;
                              var tempLegends = modalLegends;
                              temp.splice(index, 1);
                              tempLegends.splice(index, 1);
                              setModalImages([]);
                              setModalLegends([]);
                              setTimeout(() => {
                                setModalImages(temp);
                                setModalLegends(tempLegends);
                              }, 200);
                            }}
                          >
                            ✖ Șterge
                          </div> */}
                          <div className="downloadImage">
                            <a
                              href={image.match(/src="([^"]*)/)[1]}
                              download="image"
                            >
                              ⇩ Descarcă
                            </a>
                          </div>
                        </div>
                        <div
                          className="editImageText"
                          style={{
                            marginRight: "20px",
                            width: "50%",
                          }}
                        >
                          {/* <SoftInput
                          placeholder="legendă"
                          defaultValue={modalLegends[index]}
                          onChange={(e) => {
                            var temp = modalLegends;
                            var tempVal = e.target.value;
                            if (tempVal == "" || tempVal == null) tempVal = " ";
                            temp[index] = tempVal;
                            console.log(temp);

                            setModalLegends(temp);
                            // setModalLegends([]); //?
                            // setTimeout(() => {
                            //   setModalLegends(temp);
                            // }, 200);
                          }}
                        /> */}
                          <SoftEditor
                            modules={modules}
                            preserveWhitespace={true}
                            value={modalLegends[index]}
                            onChange={(value) => {
                              var temp = modalLegends;
                              var tempVal = value;
                              if (tempVal == "" || tempVal == null)
                                tempVal = " ";
                              temp[index] = tempVal;
                              console.log(temp);

                              setModalLegends(temp);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <Upload
                listType="picture-card"
                fileList={filelist}
                accept="image/*"
                customRequest={dummyRequest}
                onChange={(info) => {
                  toBase64(info.file.originFileObj).then((result) => {
                    result = '<img src="' + result + '"/>';
                    console.log(result);
                    console.log(modalImages);
                    var temp = modalImages;
                    var tempLegends = modalLegends;
                    temp.push(result);
                    tempLegends.push(" ");
                    setModalImages([]);
                    setTimeout(() => {
                      setModalImages(temp);
                      setModalLegends(tempLegends);
                    }, 200);
                  });
                }}
              >
                <div>+ Adaugă</div>
              </Upload>
            </SoftBox>
          </SoftBox>
          <Grid container spacing={3} mb={3} justifyContent={"center"}>
            <Grid item>
              {modalLoading ? (
                <SoftButton variant="contained" color="info">
                  Se încarcă...
                </SoftButton>
              ) : (
                <SoftButton
                  variant="contained"
                  color="info"
                  onClick={handleSave}
                >
                  Salvează
                </SoftButton>
              )}
            </Grid>
            <Grid item>
              <SoftButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  setModalIsOpen(false);
                  // set modal content to default values
                  setModalName("");
                  setModalText("");
                  setModalScrieri("");
                  setModalBibliografie("");
                  setModalId("");
                  setModalTraduceri("");
                  setModalEditii("");
                  setModalImages([]);
                }}
              >
                Anulează
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </Modal>
      {localStorage.getItem("token") == null ? (
        <Navigate to="/authentication/login" />
      ) : (
        <DashboardLayout>
          <DashboardNavbar />
          {/** menu with letters from a-z, horizontall */}

          {loading ? (
            <SoftBox my={3}>
              <SoftTypography variant="h6" component="h6">
                <div style={{ textAlign: "center" }}>Se încarcă...</div>
              </SoftTypography>
            </SoftBox>
          ) : (
            <SoftBox my={3}>
              <Grid container spacing={3} mb={3} justifyContent={"center"}>
                <Grid item>
                  {letters.map((letterI) => {
                    return (
                      <a
                        key={letterI}
                        href={"#" + letterI}
                        onClick={() => setLetter(letterI)}
                        style={{
                          padding: "10px",
                          color: letter == letterI ? "#17C1E8" : "inherit",
                          fontWeight: letter == letterI ? "bold" : "normal",
                        }}
                      >
                        {letterI}
                      </a>
                    );
                  })}
                </Grid>
              </Grid>
              <SoftBox mb={3}>
                <SoftButton
                  variant="contained"
                  color="info"
                  onClick={handleEdit("Adaugare intrare","", [], [], [], [], [], [], [], -1)}
                >
                  + Adaugă intrare
                </SoftButton>
              </SoftBox>
              <TimelineList title="Enciclopedia Literaturii Romane Vechi">
                {namesElement}
              </TimelineList>
            </SoftBox>
          )}
          <Footer />
        </DashboardLayout>
      )}
    </>
  );
}

export default TimelineEliv;
